import { Badge, CardTitle, Typography } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import React from 'react';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { useCommonContext } from '../../../hooks/useContexts';
import { orderNumberFormat } from '../../shared/order-number-formatter/OrderNumberFormatter';
import { dateFormat } from '../../order-details/util/format';
import { monthDayYear } from '../../../constants/dateStrings';
export var CardHeader = function (_a) {
    var _b, _c;
    var orderNumber = _a.orderNumber, POJobName = _a.POJobName, salesDate = _a.salesDate, totalAmount = _a.totalAmount, invoiceNumber = _a.invoiceNumber, registerNumber = _a.registerNumber, transactionId = _a.transactionId;
    var isMobile = useCommonContext().isMobile;
    var enableNewDeliveryTracker = FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.useTrackerAlignedUX;
    return (React.createElement(React.Fragment, null,
        React.createElement(CardTitle, { disableTypography: true, header: React.createElement(React.Fragment, null,
                enableNewDeliveryTracker &&
                    POJobName &&
                    POJobName !== orderNumber && (React.createElement("div", null,
                    React.createElement(Badge, { variant: "regular", color: "info", style: {
                            fontSize: '12px',
                            marginBottom: '12px',
                            backgroundColor: '#E3F7F6',
                            padding: '0px 8px',
                        } }, POJobName))),
                React.createElement(Typography, { weight: "bold", variant: "h3", height: "tight" }, orderNumberFormat(orderNumber, transactionId, registerNumber))), subheader: React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "body-lg", color: "subtle" },
                    salesDate
                        ? dateFormat(salesDate, monthDayYear)
                        : 'Date Unavailable',
                    ' ',
                    !enableNewDeliveryTracker &&
                        !isMobile &&
                        POJobName &&
                        POJobName !== orderNumber &&
                        "| ".concat(POJobName, " "),
                    totalAmount !== null &&
                        totalAmount !== undefined &&
                        (totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.toFixed(2)) !== 'NaN' &&
                        "| Total: ".concat(totalAmount >= 0 ? '' : '-', "$").concat((_b = (totalAmount >= 0
                            ? totalAmount
                            : totalAmount * -1)) === null || _b === void 0 ? void 0 : _b.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }), " "),
                    Boolean(invoiceNumber === null || invoiceNumber === void 0 ? void 0 : invoiceNumber.length) &&
                        typeof (invoiceNumber === null || invoiceNumber === void 0 ? void 0 : invoiceNumber[0]) === 'string' &&
                        "| Invoice #".concat(((_c = invoiceNumber === null || invoiceNumber === void 0 ? void 0 : invoiceNumber.length) !== null && _c !== void 0 ? _c : 0) > 1
                            ? invoiceNumber === null || invoiceNumber === void 0 ? void 0 : invoiceNumber.join(', #')
                            : invoiceNumber === null || invoiceNumber === void 0 ? void 0 : invoiceNumber[0], " "))), action: React.createElement("div", { className: "sui-mt-[12px]" },
                React.createElement(ArrowForward, null)) })));
};
